"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeCopy = exports.replaceUnicodeDash = exports.youtubeEmbedSanitize = void 0;
const ytDomainRegex = new RegExp('src="(http:|https:)?(//)?(www.)?youtube.com/embed/', 'ig');
const ytNoCookieReplacement = 'src="https://www.youtube-nocookie.com/embed/';
/**
 * Replace any youtube embed with the nocookie domain
 * @param copy
 * @returns
 */
const youtubeEmbedSanitize = (copy) => {
    return copy.replace(ytDomainRegex, ytNoCookieReplacement);
};
exports.youtubeEmbedSanitize = youtubeEmbedSanitize;
/** Replace dashed unicode characters that don't work on mac
 *   ex: in‑game The dash is actually unicode 8209 and not a regular hyphen
 */
const replaceUnicodeDash = (text) => {
    let finalText = text;
    if (finalText && finalText.indexOf('‑') !== -1) {
        // replace char code 8209 with 45
        finalText = finalText.replace(/‑/g, '-');
    }
    return finalText;
};
exports.replaceUnicodeDash = replaceUnicodeDash;
/**
 * Used to clean up and modify the content of a WYSIWYG field from the CMS
 * @param copy
 */
const sanitizeCopy = (copy) => {
    let sanitized = copy || '';
    sanitized = (0, exports.youtubeEmbedSanitize)(sanitized);
    sanitized = (0, exports.replaceUnicodeDash)(sanitized);
    return sanitized;
};
exports.sanitizeCopy = sanitizeCopy;
//# sourceMappingURL=contentUtils.js.map